import { render } from "./PaginationFooter.vue?vue&type=template&id=3f002e4d&scoped=true"
const script = {}

import "./PaginationFooter.vue?vue&type=style&index=0&id=3f002e4d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f002e4d"]])

export default __exports__